export const CallWaitAudio = new Audio(`${process.env.PUBLIC_URL}/audio/call_wait_audio.mp3`);

export const CallEndAudio = new Audio(`${process.env.PUBLIC_URL}/audio/call_end_audio.mp3`);

export const CallRingtoneAudio = new Audio(
  `${process.env.PUBLIC_URL}/audio/call_ringtone_audio.mp3`,
);
